/**
 * Error Handler Utility
 * 에러 처리 및 메시지 파싱 유틸리티
 */

/**
 * API 에러 타입
 */
interface ApiError {
    message?: string;
    response?: {
        data?: {
            message?: string;
        };
        status?: number;
    };
    statusCode?: number;
}

/**
 * API 에러에서 사용자 친화적인 메시지 추출
 */
export const extractErrorMessage = (error: unknown, defaultMessage = '서버 오류가 발생했습니다. 다시 시도해주세요.'): string => {
    const apiError = error as ApiError;

    // ParsedError의 message 우선 확인
    if (apiError.message && typeof apiError.message === 'string') {
        return apiError.message;
    }

    // AxiosError의 response.data.message 확인
    if (apiError.response?.data?.message && typeof apiError.response.data.message === 'string') {
        return apiError.response.data.message;
    }

    return defaultMessage;
};

/**
 * 에러 로깅 (개발 환경에서만)
 */
export const logError = (context: string, error: unknown): void => {
    if (process.env.NODE_ENV === 'development') {
        console.error(`[${context}]`, error);
    }
};

